import * as actionTypes from 'src/old/actions';

const initialState = {
  liquidationList: {
    data: [],
    meta: {}
  },
  loading: undefined
};

const liquidationListReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_LIQUIDATION_LIST: {
      return {
        ...state,
        liquidationList: action.response
      };
    }
    case actionTypes.LOADING_START: {
      return {
        ...state,
        loading: true
      };
    }
    case actionTypes.LOADING_END: {
      return {
        ...state,
        loading: false
      };
    }
    default: {
      return state;
    }
  }
};

export default liquidationListReducer;
